<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-cloud-download"></i> {{ config.title }}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-8 offset-sm-2">
      <mat-form-field [floatLabel]="'never'" class="mat-block">
        <input matInput placeholder="Name" formControlName="name" type="text" />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
          Name is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <div class="row" *ngIf="config.columnCustomizable">
    <div class="col-sm-8 offset-sm-2">
      <p>Select the columns you want to download</p>
      <div class="row">
        <div *ngFor="let column of config.columns" class="col-sm-6">
          <mat-checkbox
            [class.opaque]="column.disabled"
            [disabled]="column.disabled"
            [checked]="column.selected"
            [(ngModel)]="column.selected"
            >{{ column.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-8 offset-sm-2">
      <p [innerHTML]="config.description"></p>
    </div>
  </div>
  <div class="row" *ngIf="config.extraCheck">
    <div class="col-sm-8 offset-sm-2">
      <mat-checkbox
        [checked]="config.extraCheck.checked"
        [(ngModel)]="config.extraCheck.checked"
        [matTooltip]="config.extraCheck.tooltip"
        matTooltipPosition="above"
        matTooltipClass="text-center"
      >
        {{ config.extraCheck.title }}
      </mat-checkbox>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button
    (click)="download(form)"
    type="button"
    class="btn btn-success text-uppercase create-btn"
    [disabled]="isExporting"
  >
    <i class="fal fa-cloud-download"></i> download
  </button>
</div>
